if (!customElements.get('product-recommendation')) {
  customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
    static observedAttributes = ['data-filter-color', 'data-collection'];

    constructor() {
      super();
      this.data = '';
      this.url = ''
    }
    async connectedCallback() {
      // console.log('product-recommendation-element connected');
      // console.log(this.dataset);

      if (this.dataset.collection === "") return;

      const url = new URL(this.dataset.collection);
      url.searchParams.set('sections', 'render-recommendation');
      url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      this.url = url;

      await this.fetchData(this.url);
      await this.render();
  
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      // console.log('attribute changed', name, oldValue, newValue);
      if (oldValue === null) {
        return;
      }
      if (name === 'data-collection') {
        this.url = new URL(this.dataset.collection);
        this.url.searchParams.set('sections', 'render-recommendation');
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      }
      if (name === 'data-filter-color') {
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', newValue);
      }
      await this.fetchData(this.url);
      this.render()
    }
    render() {
      this.innerHTML = this.data;

      // disable secondary title if no parent type products in recommendations
      this.disableSecondaryTitle();

      // init easyselect
      EasySelect.init('[data-easy-select]:not(:empty)', {
        align: "top" 
      });

      // init nonMagsafe
      Array.from(this.querySelectorAll('select[name="id"]')).forEach(el => {
        this.toggleNonMagSafeForm(el);
      });

      // bind actions
      Array.from(this.querySelectorAll('select[name="id"]')).forEach(el => {
        el.addEventListener('change', (e) => {
          const image = el.closest('.product-recommendation').querySelector('img');
          // console.log('image', image);
          image.removeAttribute('srcset');
          // image.removeAttribute('src');
          image.src = e.target.querySelector('option[value="'.concat(e.target.value, '"]')).dataset.imgUrl;

          this.toggleNonMagSafeForm(e.target);
        })
      })

      Array.from(this.querySelectorAll('[data-filter-group-param]')).forEach(el => {
        el.addEventListener('change', e => {
          this.url.searchParams.set(e.target.dataset.filterGroupParam, decodeURIComponent(e.target.value));
          this.dataset.collection = decodeURIComponent(this.url.toString());
        })
      });
    }
    async fetchData(url) {
      console.log(`fetching recommendations from ${url}`);
      const response = await fetch(url);
      const json = await response.json();
      const parser = new DOMParser();
      const html = parser.parseFromString(json['render-recommendation'], 'text/html');
      // return html.getElementById('shopify-section-render-recommendation').innerHTML;
      this.data = html.getElementById('shopify-section-render-recommendation').innerHTML;
    }

    toggleNonMagSafeForm(el) {
      const nonMagSafeForm = el.closest('.product-recommendation').querySelector('[data-variants]');
      if (nonMagSafeForm) {
        const data = JSON.parse(atob(nonMagSafeForm.dataset.variants));
        const nonMagSafeItem = data.find(item => item.color === el.selectedOptions[0].label);

        if (nonMagSafeItem && nonMagSafeItem.available) {
          nonMagSafeForm.elements.id.value = nonMagSafeItem.variant;
          nonMagSafeForm.classList.remove('hidden');
          nonMagSafeForm.closest('div').classList.add('grid', 'grid-cols-2');
        } else {
          nonMagSafeForm.classList.add('hidden');
          nonMagSafeForm.closest('div').classList.remove('grid', 'grid-cols-2');
        }

        const variantAvailable = el.selectedOptions[0].dataset.available === 'true';
        const addToCartBtn = this.querySelector('[type="submit"][form="'.concat(this.querySelector('.product-form form').getAttribute('id'),'"]'));
        if (variantAvailable) {
          addToCartBtn.querySelector('span').innerText = addToCartBtn.dataset.translationAddToCart;
          addToCartBtn.disabled = false;
        }
        else {
          addToCartBtn.querySelector('span').innerText = addToCartBtn.dataset.translationSoldOut;
          addToCartBtn.disabled = true;
        }

        const image = el.closest('.product-recommendation').querySelector('img');
        image.removeAttribute('srcset');
        if (image.src !== el.selectedOptions[0].dataset.imgUrl) {
          image.src = el.selectedOptions[0].dataset.imgUrl
        }
      }
    }
    disableSecondaryTitle() {
      const recommendationHasParentTypes = this.dataset.recommendationsContainsParentTypes === 'true';
      if (!recommendationHasParentTypes) {
        const titleEl = this.querySelector('.product-recommendation__group-title span');
        if (titleEl) {
          titleEl.remove();
        }
      }
    }
  })
}